import script from "./MonthTopics.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthTopics.vue?vue&type=script&setup=true&lang=js"

import "./MonthTopics.vue?vue&type=style&index=0&id=eafccbde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eafccbde"]])

export default __exports__